"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SecureSocksProxyToggle = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const ui_1 = require("@grafana/ui");
const runtime_1 = require("@grafana/runtime");
const SecureSocksProxyToggle = (_a) => {
    var { labelWidth = 10 } = _a, props = tslib_1.__rest(_a, ["labelWidth"]);
    const { dataSourceConfig, onChange } = props;
    const handleSwitchChange = (e) => {
        onChange(Object.assign(Object.assign({}, dataSourceConfig), { jsonData: Object.assign(Object.assign({}, dataSourceConfig.jsonData), { enableSecureSocksProxy: e.target.checked }) }));
    };
    return (runtime_1.config.secureSocksDSProxyEnabled && (react_1.default.createElement("div", null,
        react_1.default.createElement("div", { className: "gf-form" },
            react_1.default.createElement("div", { className: "gf-form gf-form-inline" },
                react_1.default.createElement(ui_1.InlineField, { htmlFor: "secureSocksProxyEnabled", label: "Secure Socks Proxy Enabled", labelWidth: labelWidth, tooltip: react_1.default.createElement(react_1.default.Fragment, null,
                        "Proxy the datasource connection through the secure socks proxy to a different network. To learn more about configuring the datasource connection proxy,",
                        ' ',
                        react_1.default.createElement("a", { href: "https://grafana.com/docs/grafana/latest/setup-grafana/configure-grafana/proxy/", target: "_blank", rel: "noopener noreferrer" }, "click here.")) },
                    react_1.default.createElement(ui_1.InlineSwitch, { id: "secureSocksProxyEnabled", value: dataSourceConfig.jsonData.enableSecureSocksProxy, onChange: handleSwitchChange })))))));
};
exports.SecureSocksProxyToggle = SecureSocksProxyToggle;
//# sourceMappingURL=SecureSocksProxyToggle.js.map